'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'dog';
var width = 576;
var height = 512;
var aliases = [128021];
var unicode = 'f6d3';
var svgPathData = 'M328.5-12.9c2.7-13 15.4-21.3 28.4-18.6s21.3 15.4 18.6 28.4l-.7 3.1 54.7 0 8.7 .4c20.1 2 39.1 10.9 53.5 25.3l6.2 6.2 54.1 0 2.5 .1C566.6 33.4 576 43.6 576 56l0 48c0 57.4-46.6 104-104 104l-20.3 0-3.7 18.4 0 229.6c0 30.9-25.1 56-56 56l-32 0c-30.9 0-56-25.1-56-56l0-67.9c-31.2 10.4-64.8 10.4-96 0l0 67.9c0 30.9-25.1 56-56 56l-32 0c-30.9 0-56-25.1-56-56l0-251.4C27.1 194.1 0 160.3 0 120 0 106.7 10.7 96 24 96s24 10.7 24 24c0 22.1 17.9 40 40 40l204.5 0 36-172.9zM112 456c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-104c0-8.1 4.1-15.7 10.9-20.1s15.4-5.1 22.8-1.8l20 8.9 5.1 2.1c25.6 9.8 54.2 9.1 79.4-2.1l20-8.9c7.4-3.3 16-2.6 22.8 1.8S352 343.9 352 352l0 104c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-218.5-68.9-29.5-219.1 0 0 248zM341.5 160.2l65.2 27.9 1.8-8.9 1.2-4C413.2 166.2 422 160 432 160l40 0c30.9 0 56-25.1 56-56l0-24-40 0c-6.4 0-12.5-2.5-17-7L457.8 59.7C450.3 52.2 440.1 48 429.5 48l-64.7 0-23.4 112.2zM432 108a20 20 0 1 1 0-40 20 20 0 1 1 0 40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDog = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;